import { useEffect } from "react";

export function useFadeInOnScroll() {
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in, .fade-in-up");

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const el = entry.target;

          // Calcula um delay progressivo (0s, 0.1s, 0.2s, 0.3s...)
          const delay = index * 0.1;
          el.style.animationDelay = `${delay}s`;

          el.style.animationPlayState = "running";
          observer.unobserve(el); // anima apenas uma vez
        }
      });
    });

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}